import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BREAKPOINTS, HOTELS_MAX_GUEST_IN_RESERVATION, HOTELS_MAX_ROOMS_IN_RESERVATION } from "@lib/constants";
import useAfterInitEffect from "@lib/hooks/use-after-initialization-effect";
import { getTotalGuestsQtyFromHotelOccupationArray } from "@lib/util/hotels/search-ops";
import { IconButton, MuscleButton } from "@modules/shared/components/buttons";
import MuscleDropdown from "@modules/shared/components/dropdown";
import ErrorMessageCard from "@modules/shared/components/error-message-card";
import MuscleQuantityToggler from "@modules/shared/components/quantity-toggler";
import Icons from "@modules/icons";
import { useTranslations } from "next-intl";
import React, { useMemo, useState, forwardRef } from "react";
import { useMediaQuery } from "react-responsive";
import { GenericSelectInput } from "@modules/shared/components/generic-select-input";
const HotelsOccupationsInput = _ref => {
  let {
    selectedOccupations,
    setSelectedOccupations,
    disable = false
  } = _ref;
  const ref = /*#__PURE__*/React.createRef();
  const {
    0: dropdownIsOpen,
    1: setDropdownIsOpen
  } = useState(false);
  const addOccupation = () => {
    setSelectedOccupations([...selectedOccupations, {
      adults: 1,
      children: 0,
      children_ages: []
    }]);
  };
  const removeOccupation = index => {
    const newOccupations = selectedOccupations.filter((_, i) => i !== index);
    setSelectedOccupations(newOccupations);
  };
  const updateOccupation = (index, occupation) => {
    const newOccupations = [...selectedOccupations];
    newOccupations[index] = occupation;
    setSelectedOccupations(newOccupations);
  };
  return __jsx("div", {
    className: "flex flex-col relative"
  }, __jsx(OccupationsInputButton, {
    selectedOccupations: selectedOccupations,
    isOpen: dropdownIsOpen,
    setIsOpen: setDropdownIsOpen,
    ref: ref,
    disable: disable
  }), __jsx(OccupationsInputDropdown, {
    isOpen: dropdownIsOpen,
    buttonRef: ref,
    setIsOpen: setDropdownIsOpen,
    selectedOccupations: selectedOccupations,
    addOccupation: addOccupation,
    removeOccupation: removeOccupation,
    updateOccupation: updateOccupation
  }));
};
const OccupationsInputButton = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    isOpen,
    setIsOpen,
    selectedOccupations,
    disable = false,
    dataTestId
  } = _ref2;
  const t = useTranslations("Hotels");
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const renderArrow = () => {
    if (disable) {
      return null;
    }
    return isOpen ? __jsx(Icons.chevronUp, null) : __jsx(Icons.chevronDown, null);
  };
  const renderButtonInformation = (icon, text) => {
    return __jsx("div", {
      className: "flex flex-row items-center gap-1",
      onClick: () => disable || isMobile ? {} : setIsOpen(!isOpen)
    }, icon, __jsx("p", {
      className: "tx-psm-semiBold"
    }, text));
  };
  return __jsx("div", {
    ref: ref,
    className: "flex flex-row gap-4 text-home-selectors items-center clickable",
    onClick: () => disable || isMobile ? {} : setIsOpen(!isOpen),
    "data-testid": dataTestId
  }, renderButtonInformation(__jsx(Icons.bed, {
    size: 19
  }), "".concat(selectedOccupations.length, " ").concat(t("ROOMS", {
    count: selectedOccupations.length
  }))), renderButtonInformation(__jsx(Icons.personIconFilled, {
    size: 12
  }), "".concat(getTotalGuestsQtyFromHotelOccupationArray(selectedOccupations), " ").concat(t("GUESTS", {
    count: getTotalGuestsQtyFromHotelOccupationArray(selectedOccupations)
  }))), renderArrow());
});
OccupationsInputButton.displayName = "OccupationsInputButton";
const OccupationsInputDropdown = _ref3 => {
  let {
    isOpen,
    setIsOpen,
    selectedOccupations,
    addOccupation,
    removeOccupation,
    updateOccupation,
    buttonRef
  } = _ref3;
  const t = useTranslations();
  const totalGuestsInReservation = useMemo(() => getTotalGuestsQtyFromHotelOccupationArray(selectedOccupations), [selectedOccupations]);
  const allChildrenAgesEntered = useMemo(() => selectedOccupations.every(occupation => !occupation.children_ages.includes(null)), [selectedOccupations]);
  const {
    0: showCompleteChildrenAges,
    1: setShowCompleteChildrenAges
  } = useState(false);
  useAfterInitEffect(() => {
    if (!isOpen) {
      if (!allChildrenAgesEntered) {
        setIsOpen(true);
        setShowCompleteChildrenAges(true);
      } else {
        setShowCompleteChildrenAges(false);
      }
    }
  }, [isOpen]);
  const renderOccupationInputs = () => {
    return selectedOccupations.map((occupation, index) => {
      return __jsx(OccupationInput, {
        key: index,
        index: index,
        occupation: occupation,
        updateThisOccupation: occupation => updateOccupation(index, occupation),
        removeThisOccupation: () => removeOccupation(index),
        otherOccupations: selectedOccupations.filter((_, i) => i !== index)
      });
    });
  };
  return __jsx(MuscleDropdown, {
    isOpenState: isOpen,
    setIsOpenState: setIsOpen,
    buttonRef: buttonRef
  }, __jsx("div", {
    className: "flex flex-col gap-4 p-4 w-72"
  }, renderOccupationInputs(), __jsx(MuscleButton, {
    variant: "outlineXL",
    onClick: addOccupation,
    disabled: totalGuestsInReservation === HOTELS_MAX_GUEST_IN_RESERVATION || selectedOccupations.length === HOTELS_MAX_ROOMS_IN_RESERVATION
  }, __jsx(Icons.circlePlusOutline, {
    className: "min-w-4 min-h-4"
  }), t("Hotels.InputsBar.ADD_ROOM")), showCompleteChildrenAges && !allChildrenAgesEntered && __jsx(React.Fragment, null, __jsx(ErrorMessageCard, {
    message: t("Hotels.InputsBar.ERRORS.COMPLETE_CHILDREN_AGES"),
    textClassname: "text-xs"
  })), __jsx(MuscleButton, {
    dataTestId: "hotels-occupations-input-ready-button",
    variant: "solidXL",
    onClick: () => setIsOpen(false)
  }, t("Hotels.InputsBar.READY"))));
};
const OccupationInput = _ref4 => {
  let {
    index,
    updateThisOccupation,
    occupation,
    removeThisOccupation,
    otherOccupations
  } = _ref4;
  const t = useTranslations();
  const totalGuestsInOtherOccupations = useMemo(() => getTotalGuestsQtyFromHotelOccupationArray(otherOccupations), [otherOccupations]);
  const renderGuestTypeQtyInput = (label, description, value, onIncrement, onDecrement, minValue, maxValue) => {
    return __jsx("div", {
      className: "flex flex-row gap-2 justify-between"
    }, __jsx("div", {
      className: "flex flex-col"
    }, __jsx("p", {
      className: "tx-psm-semiBold text-primary_text"
    }, label), __jsx("p", {
      className: " tx-psm-regular md:tx-pxs-regular text-primary_text"
    }, description)), __jsx(MuscleQuantityToggler, {
      value: value,
      incrementValue: onIncrement,
      decrementValue: onDecrement,
      minValue: minValue,
      maxValue: maxValue
    }));
  };
  const renderChildrenAgesInputs = () => {
    return occupation.children_ages.map((age, index) => __jsx(GenericSelectInput, {
      key: index,
      label: t("Hotels.InputsBar.CHILD_AGE", {
        count: index + 1
      }),
      value: age !== null ? age : undefined,
      options: Array.from({
        length: 18
      }, (_, i) => ({
        key: i.toString(),
        value: i
      })),
      placeholder: "",
      onSelect: selectedValue => setChildrenAgeAtIndex(index, selectedValue)
    }));
  };
  const setChildrenAgeAtIndex = (index, age) => {
    const newChildrenAges = [...occupation.children_ages];
    newChildrenAges[index] = age;
    updateThisOccupation(_objectSpread(_objectSpread({}, occupation), {}, {
      children_ages: newChildrenAges
    }));
  };
  const incrementChildren = () => {
    updateThisOccupation(_objectSpread(_objectSpread({}, occupation), {}, {
      children: occupation.children + 1,
      children_ages: [...occupation.children_ages, null]
    }));
  };
  const decrementChildren = () => {
    updateThisOccupation(_objectSpread(_objectSpread({}, occupation), {}, {
      children: occupation.children - 1,
      children_ages: occupation.children_ages.slice(0, -1)
    }));
  };
  return __jsx("div", {
    className: "flex flex-col gap-2"
  }, __jsx("div", {
    className: "flex flex-row gap-4 items-center justify-between text-primary-main mb-2"
  }, __jsx("p", {
    className: "tx-pmd-semiBold"
  }, "".concat(t("Hotels.ROOM"), " ").concat(index + 1)), index > 0 ? __jsx(IconButton, {
    icon: __jsx(Icons.circleX, {
      size: 15
    }),
    onClickButton: removeThisOccupation
  }) : null), renderGuestTypeQtyInput(t("Hotels.GuestType.ADULTS"), t("Hotels.GuestType.ADULTS_DESCRIPTION"), occupation.adults, () => updateThisOccupation(_objectSpread(_objectSpread({}, occupation), {}, {
    adults: occupation.adults + 1
  })), () => updateThisOccupation(_objectSpread(_objectSpread({}, occupation), {}, {
    adults: occupation.adults - 1
  })), 1, HOTELS_MAX_GUEST_IN_RESERVATION - (totalGuestsInOtherOccupations + occupation.children)), renderGuestTypeQtyInput(t("Hotels.GuestType.CHILDREN"), t("Hotels.GuestType.CHILDREN_DESCRIPTION"), occupation.children, incrementChildren, decrementChildren, 0, HOTELS_MAX_GUEST_IN_RESERVATION - (totalGuestsInOtherOccupations + occupation.adults)), __jsx("div", {
    className: "flex flex-wrap gap-2 w-full"
  }, renderChildrenAgesInputs()));
};
export default HotelsOccupationsInput;